import { render, staticRenderFns } from "./DeleteSpaces.vue?vue&type=template&id=206ff22c"
import script from "./DeleteSpaces.vue?vue&type=script&lang=ts"
export * from "./DeleteSpaces.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports